// interface SnackbarConfig {
//     id: string;
//     title: string;
//     duration?: number;
//     closeable?: boolean;
//     color?: 'default' | 'error' | 'warning' | 'info' | 'success'; // Alineado con los VariantType de notistack/MUI
//     position?: SnackbarPosition;
//     icon?: React.ElementType; // Opcional, en caso de que quieras usar un ícono específico
// }

import { SnackbarConfig } from "../../store";

export const successAddDefault: SnackbarConfig = {
    id: 'success',
    title: 'Se ha creado el registro con éxito',
    color: 'success',
    duration: 5000,
    closeable: true,
    position: "bottom-center"
}

export const successEditDefault: SnackbarConfig = {
    id: 'success',
    title: 'Se ha editado el registro con éxito',
    color: 'success',
    duration: 5000,
    closeable: true,
    position: "bottom-center"

}

export const successDeleteDefault: SnackbarConfig = {
    id: 'success',
    title: 'Se ha eliminado el registro con éxito',
    color: 'success',
    duration: 5000,
    closeable: true,
    position: "bottom-center"

}

export const errorDefault: SnackbarConfig = {
    id: 'error',
    title: 'Ha ocurrido un error',
    color: 'error',
    duration: 5000,
    closeable: true,
    position: "bottom-center"

}

